if (!customElements.get('appointment-form')) {
  customElements.define('appointment-form', class AppointmentForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.errorMsg = this.querySelector('.appointment-form__error');
      this.successMsg = this.querySelector('.appointment-form__success');
      
      this.productTitle = this.dataset.productTitle;
      this.productHandle = this.dataset.productHandle;
      this.productImage = this.dataset.productImage;
      this.productSku = this.dataset.productSku;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (this.submitButton.classList.contains('loading')) return;

      this.submitButton.classList.add('loading');
      this.errorMsg.hidden = true;
      this.successMsg.hidden = true;

      const productionDomain = 'https://cartersjewelchest.com';
      const normalizeUrl = (url) => {
        if (!url) return url;
        let newUrl = url;
        if (newUrl.startsWith('//')) {
          newUrl = 'https:' + newUrl;
        } else if (newUrl.startsWith('/')) {
          newUrl = window.location.origin + newUrl;
        }
        
        // If we're on localhost, replace it with the production domain so images/links work in email
        if (newUrl.includes('localhost') || newUrl.includes('127.0.0.1')) {
          newUrl = newUrl.replace(/https?:\/\/[^\/]+/, productionDomain);
        }
        return newUrl;
      };

      // Try to get the live image from the DOM
      const liveImage = document.querySelector('.hotspot-container img');
      let finalImage = liveImage ? liveImage.src : this.productImage;
      finalImage = normalizeUrl(finalImage);

      // Ensure image is a reasonable size for email (replace large width parameters)
      if (finalImage.includes('width=')) {
        finalImage = finalImage.replace(/width=\d+/, 'width=400');
      }

      // Try to get the live SKU from the DOM
      const liveSku = document.querySelector('.product__sku');
      const finalSku = (liveSku && liveSku.innerText.replace(/Style #:|SKU:/i, '').trim()) || this.productSku;

      const formData = new FormData(this.form);
      const data = {
        name: formData.get('name'),
        email: formData.get('email'),
        phone: formData.get('phone'),
        date: formData.get('date'),
        time: formData.get('time'),
        message: formData.get('message'),
        productTitle: this.productTitle,
        productUrl: normalizeUrl(window.location.href),
        productImage: finalImage,
        productSku: finalSku
      };

      // Cloudflare Worker URL
      const WORKER_URL = 'https://cjc-view-item-appt.austin-1e7.workers.dev/api/appointment';

      fetch(WORKER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(result => {
        this.successMsg.hidden = false;
        this.form.reset();
        // Close modal after delay
        setTimeout(() => {
          if (typeof Woolman !== 'undefined' && Woolman.ModalsAndDrawers) {
            Woolman.ModalsAndDrawers.closeAll();
          }
          const attrelleModal = document.querySelector('dialog[attrelle*="global-appointment-modal"]');
          if (attrelleModal && typeof attrelleModal.close === 'function') {
            attrelleModal.close();
            document.body.classList.remove('no-scroll');
          }
        }, 5000);
      })
      .catch(error => {
        console.error('Error:', error);
        this.errorMsg.hidden = false;
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
      });
    }
  });
}
